import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { epApi, errorText } from '../api';

/**
 * "Don't see a program? Paste its website." Students, parents and counselors.
 * GradMap reads the page, a person checks it, and the sender gets a notice when it is added.
 */
export default function SuggestProgram({ openHref }: { openHref?: (id: number) => string }) {
  const history = useHistory();
  const [url, setUrl] = useState('');
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<{ tone: 'ok' | 'err'; text: string; programId?: number } | null>(null);
  const send = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!url.trim()) return;
    setBusy(true);
    setMsg(null);
    try {
      const r = await epApi.suggestProgram(url.trim());
      if (r.status === 'exists' && r.program) {
        setMsg({ tone: 'ok', text: `${r.program.name} is already on GradMap.`, programId: r.program.id });
      } else {
        setMsg({ tone: 'ok', text: "Thanks! We'll check it and let you know when it's on GradMap, usually within a few days." });
        setUrl('');
      }
    } catch (err) {
      setMsg({ tone: 'err', text: errorText(err, 'That link did not work. Paste the program page address, for example https://example.edu/summer') });
    } finally {
      setBusy(false);
    }
  };
  return (
    <section className="card ep-suggest" aria-label="Suggest a program">
      <h3 style={{ fontSize: 15 }}>Don't see a program?</h3>
      <p className="body small" style={{ marginTop: 4 }}>Paste its website and we'll add it.</p>
      <form className="row" style={{ marginTop: 10, flexWrap: 'nowrap' }} onSubmit={send}>
        <input
          className="in"
          type="url"
          inputMode="url"
          aria-label="Program website"
          placeholder="https://example.edu/summer-program"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          maxLength={500}
        />
        <button type="submit" className="btn primary" disabled={busy || !url.trim()}>{busy ? 'Sending' : 'Send'}</button>
      </form>
      {msg && (
        <p className={`small ${msg.tone === 'err' ? 'red' : ''}`} style={{ marginTop: 8 }} role="status">
          {msg.text}{' '}
          {msg.programId && (
            <button type="button" className="linkish small" onClick={() => history.push(openHref ? openHref(msg.programId!) : `/summer-programs/programs?id=${msg.programId}`)}>
              Open it
            </button>
          )}
        </p>
      )}
    </section>
  );
}
